module.exports = __webpack_public_path__ + "static/planet-fd0421c7d552f41d5b8f2a64cb7554a1.png";